<div class="transfer-vehicle-dialog">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="columns">
      <div class="icon">
        <div><i class="fal fa-sync-alt pt-1"></i></div>
      </div>
      <div class="text">
        <div class="heading">Transfer Vehicle</div>
        <div class="sub-header">It is recommended to transfer vehicle to maintain vehicle service history</div>
      </div>
      <div class="close">
        <i class="fal fa-times fa-sm dialog-close font-300" (click)="closeModal()"></i>
      </div>
    </div>
  </div>

  <div class="dialog-body p-0">
    <div class="ui-g-12 vehicle-details">
      <div class="ui-g-1 flex-center-center">
        <i class="fal fa-car"></i>
      </div>
      <div class="ui-g-5">
        <div class="heading">Vin Number</div>
        <div class="sub-header">{{ transferVehicle.vehicleDetail.VIN }}</div>
      </div>
      <div class="ui-g-1"></div>
      <div class="ui-g-5">
        <div class="heading">Vehicle Name</div>
        <div class="sub-header">{{ transferVehicle.vehicleDetail.name }}</div>
      </div>
    </div>
    <div class="ui-g-12 border-divider"></div>
    <div class="ui-g-12 p-0">
      <div class="transfer-vehicle">Transfer Vehicle</div>

      <div class="ui-g-5 transfer-vehicle-detail">
        <div class="flex-center-center">
          <i class="fal fa-user"></i>
        </div>
        <div>
          <div class="heading">Current Owner</div>
          <div class="sub-header">{{ transferVehicle.transferFrom }}</div>
        </div>
      </div>
      <div class="ui-g-2 flex-center-center height-68">
        <i class="fal fa-arrow-right"></i>
      </div>
      <div class="ui-g-5 transfer-vehicle-detail">
        <div class="flex-center-center">
          <i class="fal fa-user"></i>
        </div>
        <div>
          <div class="heading">Transfer to</div>
          <div class="sub-header">{{ transferVehicle.transferTo }}</div>
        </div>
      </div>
    </div>
    <div class="ui-g-12 border-divider" *ngIf="transferVehicle?.transferHistory?.length > 0"></div>

    <div class="ui-g-12 p-0 transfer-history" *ngIf="transferVehicle?.transferHistory?.length > 0">
      <div class="transfer-vehicle">Transfer History</div>
      <div class="scroll-body">
        <table>
          <tr>
            <th>Transferred from</th>
            <th>Transferred to</th>
            <th>Date</th>
          </tr>
          <tr *ngFor="let vehicle of transferVehicle?.transferHistory">
            <td>{{ vehicle?.previousCustomerName }}</td>
            <td>{{ vehicle?.currentCustomerName }}</td>
            <td>{{ vehicle?.vehicleTransferDate }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="p-zero text-right float-right mt-1 mb-1">
      <button class="btn btn-white btn-border pointer btn-submit mr-1" (click)="closeModal()">Cancel</button>
      <button class="btn btn-primary btn-submit font-bold ml-1" (click)="handleSubmit()">
        <span class="" [ngClass]="{ 'pr-2': isProcessing }">Transfer and save</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate ml-1"></i>
      </button>
    </div>
  </div>
</div>
